module.exports = __webpack_public_path__ + "static/media/crocodile(25).212c603b.PNG";